import React from 'react';
import styled from 'styled-components';

import type { DepartureOption } from '@lt/api/dist/types/departure';
import type { SearchType } from '../../components/Cigarette/types';

import { WidgetName } from '../../models';
import { INITIAL_VALUES_FORMIK } from '../../components/Cigarette/constants';

import CigaretteWidget from '../Cigarette/CigaretteWidget';
import Cigarette from '../../components/Cigarette';
import CopyButton from '../../components/CopyButton';

interface ICigaretteConstructor {
  isBlankBackground: boolean;
  searchType: SearchType;
  departure?: DepartureOption;
  isTabsSwitchOn: boolean;
}

export const CigaretteConstructor = (props: ICigaretteConstructor): JSX.Element => {
  const { searchType, departure } = props;

  return (
    <>
      <CigaretteWidget
        searchType={searchType}
        initialValues={{ ...INITIAL_VALUES_FORMIK, departure }}
      />
      <CopyButton widgetName={WidgetName.CIGARETTE} />
    </>
  );
};

export const StyledCigaretteContainer = styled.div<{
  $color?: string;
  $isMobile: boolean;
  $hasMargins?: boolean;
}>`
  ${({ $color }) => ($color ? `background: ${$color};` : '')}

  padding: 8px;
  margin: ${({ $hasMargins }) => ($hasMargins ? 8 : 0)}px auto;
  border-radius: 4px;
  max-width: 100%;
  width: ${({ $hasMargins }) => ($hasMargins ? 'calc(100% - 16px)' : '100%')};

  /* не перекрывать раскрытое меню другой сигареты */
  & > form {
    z-index: auto;
  }

  ${({ $isMobile, $hasMargins }) =>
    $isMobile
      ? `
    width: ${$hasMargins ? 'calc(100% - 8px)' : '100%'};
    & > form {
      background: #F3F2E8;
    }
    & div {
      border-color: #fff !important;
    }
  `
      : `
    height: 72px;

    & > form {
      position: absolute;
    }
    `}
`;

export const StyledCigarette = styled(Cigarette)<{
  $isMobile: boolean;
  $withoutButton?: boolean;
  $width?: number;
}>`
  position: relative;
  margin: 0 auto;

  ${({ $withoutButton }) => ($withoutButton ? '& > :last-child { display: none; }' : '')}

  ${({ $isMobile, $width }) =>
    $isMobile
      ? `
  & > div:first-child,
  & > .cigarette__field-border {
    width: 100% !important;
    max-width: 100% !important;
  };`
      : `
  ${$width && `width: ${$width}px !important;`}
  & .react-datepicker {
    left: 50%;
    transform: translateX(-50%);
  }
`};
`;
